<div class="dialog-container">
  @if (currentView === 'login') {
    <div>
      <h2>Mitarbeiter-Login</h2>
      <form [formGroup]="loginData" (ngSubmit)="submitData()" method="post">
        <mat-form-field appearance="fill" color="accent">
          <mat-label>E-Mail</mat-label>
          <input matInput formControlName="email" [maxlength]="constants.maxInput" required>
          @if (loginData.get('email')?.invalid) {
            <mat-error>Keine gültige E-Mail Adresse</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill" color="accent">
          <mat-label>Passwort</mat-label>
          <input matInput placeholder="*******" [type]="hide ? 'password' : 'text'" formControlName="password"
            [maxlength]="constants.maxInput" required>
          <mat-icon matSuffix class="clickable" (click)="hide = !hide">
            {{ hide ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </mat-form-field>
        <div class="form-buttons-container">
          <button mat-button type="button" class="forgot-password" (click)="switchToForgotPassword()">
            Passwort vergessen?
          </button>
          <button mat-raised-button color="primary" type="submit"
          [disabled]="loginData.get('email')?.invalid || loginData.get('password')?.invalid">Anmelden</button>
        </div>
      </form>
      <div class="dialog-actions">
        <button mat-button class="secondary-button" (click)="onSecondaryClick()">
          Zurück
        </button>
      </div>
    </div>
  }
  @if (currentView === 'reset-request') {
    <div>
      <h2>Passwort zurücksetzen</h2>
      <form [formGroup]="resetRequestForm" (ngSubmit)="requestResetToken()">
        <mat-form-field appearance="fill">
          <mat-label>E-Mail</mat-label>
          <input matInput formControlName="email" required>
        </mat-form-field>
        <button mat-raised-button color="primary" type="submit" [disabled]="resetRequestForm.invalid">Passwort zurücksetzen</button>
      </form>
      <div class="dialog-actions">
        <button mat-button class="secondary-button" (click)="switchToLogin()">Zurück zum Login</button>
      </div>
    </div>
  }

  @if (currentView === 'reset-info') {
    <div>
      <h2>E-Mail versendet</h2>
      <p class="info-text">
        Wenn die angegebene E-Mail-Adresse bei uns registriert ist, erhältst du in Kürze eine Nachricht mit weiteren Anweisungen zum Zurücksetzen deines Passworts.
      </p>
      <div class="dialog-actions">
        <button mat-button class="secondary-button" (click)="switchToLogin()">Zurück zum Login</button>
      </div>
    </div>
  }

</div>